import './SuccessStories.css';
import content from '../data/content.json';

const SuccessStories: React.FC = () => {
  return (
    <section className="success-stories" id="casos">
      <div className="container">
        <h2>{content.successStories.title}</h2>

        <div className="cases-grid">
          {content.successStories.cases.map((caseItem, index) => (
            <div key={index} className="case-card">
              <h3>{caseItem.title}</h3>
              <p className="case-client"><strong>Cliente:</strong> {caseItem.client}</p>
              <p className="case-result"><strong>Resultado:</strong> {caseItem.result}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuccessStories;
